import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=6040b329&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=6040b329&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6040b329",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6040b329')) {
      api.createRecord('6040b329', component.options)
    } else {
      api.reload('6040b329', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=6040b329&scoped=true", function () {
      api.rerender('6040b329', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layouts/main/components/Sidebar.vue"
export default component.exports